import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("oskar_auth_token"));
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("oskar_auth_user")); } catch { return null; }
  });
  const [activeCompany, setActiveCompanyState] = useState(() => {
    try { return JSON.parse(localStorage.getItem("oskar_auth_company")); } catch { return null; }
  });
  const [companies, setCompanies] = useState(() => {
    try { return JSON.parse(localStorage.getItem("oskar_auth_companies")); } catch { return []; }
  });
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    setAuthLoading(false);
  }, []);

  function login(data) {
    const { access_token, user, companies, active_company } = data;
    setToken(access_token);
    setUser(user);
    setCompanies(companies || []);
    const company = active_company || (companies?.length === 1 ? companies[0] : null);
    setActiveCompanyState(company);
    localStorage.setItem("oskar_auth_token", access_token);
    localStorage.setItem("oskar_auth_user", JSON.stringify(user));
    localStorage.setItem("oskar_auth_companies", JSON.stringify(companies || []));
    localStorage.setItem("oskar_auth_company", JSON.stringify(company));
  }

  function setActiveCompany(company) {
    setActiveCompanyState(company);
    localStorage.setItem("oskar_auth_company", JSON.stringify(company));
  }

  function updateUser(patch) {
    setUser((prev) => {
      const updated = { ...prev, ...patch };
      localStorage.setItem("oskar_auth_user", JSON.stringify(updated));
      return updated;
    });
  }

  function logout() {
    setToken(null);
    setUser(null);
    setActiveCompanyState(null);
    setCompanies([]);
    localStorage.removeItem("oskar_auth_token");
    localStorage.removeItem("oskar_auth_user");
    localStorage.removeItem("oskar_auth_company");
    localStorage.removeItem("oskar_auth_companies");
    // also clear legacy key
    localStorage.removeItem("bidco_auth");
  }

  // Migrate legacy bidco_auth key if present
  useEffect(() => {
    const legacy = localStorage.getItem("bidco_auth");
    if (legacy && !token) {
      try {
        const parsed = JSON.parse(legacy);
        if (parsed?.access_token) {
          setToken(parsed.access_token);
          setUser(parsed.user || null);
          localStorage.setItem("oskar_auth_token", parsed.access_token);
          localStorage.setItem("oskar_auth_user", JSON.stringify(parsed.user || null));
        }
      } catch {}
      localStorage.removeItem("bidco_auth");
    }
  }, []);

  return (
    <AuthContext.Provider value={{ token, user, activeCompany, companies, authLoading, setActiveCompany, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export { AuthContext };
